import React from 'react';
import Admin from '../components/Constructor/Admin/Admin.js';
import '../components/Constructor/index.scss';
import PersonalCabinet from "./PersonalCabinet";



const ConstructorAdmin = (props) => {
  return  <>
      <PersonalCabinet/>
      <Admin />
    </>
};

export default ConstructorAdmin
